import {faX} from '@awesome.me/kit-d4c1b300b9/icons/kit/custom';
import {forwardRef} from '@chakra-ui/react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {IconButton} from './IconButton';
import type {UIIconButtonProps} from './typings';

export const RemoveIconButton = forwardRef<UIIconButtonProps, 'button'>((props, ref) => (
  <IconButton size={`xs`} aria-label={`remove`} icon={<FontAwesomeIcon icon={faX} />} {...props} ref={ref} />
));
